import * as scroll from '../util/body-scroll';
import { enableAfterFirstAnimation } from '../util/event-handlers';

/* Constants */
const BURGER = '#header-burger';
const BACK_BTN = '#services-back';
const WRAPPER = '.mobile-menu-wrapper';
const MENU = '.mobile-menu';
const ACTIVE = 'is-active';
const SHOW_SERVICES = 'show-services';
const DROPDOWN = '.menu-products-dropdown';

/* Functions */
const showServices = id => jQuery(MENU).addClass(SHOW_SERVICES).addClass(id);
const hideServices = () => {
  jQuery(MENU)
    .removeClass(SHOW_SERVICES)
    .removeClass('repentigny')
    .removeClass('assomption');
};

const toggleMenu = () => {
  jQuery(`${MENU}, ${BURGER}, ${WRAPPER}`).each((_i, el) => {
    const wasActive = jQuery(el).hasClass(ACTIVE);
    jQuery(el)[wasActive ? 'removeClass' : 'addClass'](ACTIVE);
    scroll[wasActive ? 'unlock' : 'lock']();
    hideServices();
  });
};

const init = () => {
  enableAfterFirstAnimation(WRAPPER);

  jQuery(BURGER).on('click', toggleMenu);

  jQuery(BACK_BTN).on('click', hideServices);

  jQuery(`${MENU} ${DROPDOWN}`).each((_index, el) => {
    jQuery(el).on('click', function (e) {
      const id = jQuery(this).data('id');
      e.preventDefault();
      showServices(id);
    });
  });
};

export default init;
